import { render } from "./StepCard.vue?vue&type=template&id=0b9cf01f&scoped=true"
import script from "./StepCard.vue?vue&type=script&lang=js"
export * from "./StepCard.vue?vue&type=script&lang=js"

import "./StepCard.vue?vue&type=style&index=0&id=0b9cf01f&lang=scss&scoped=true"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b9cf01f"]])

export default __exports__